var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('contact-card',{staticClass:"tw-m-8",attrs:{"loading":_vm.loading,"type":_vm.type,"contact":_vm.contact},on:{"updated":_vm.onEdit,"removed":_vm.onDelete}})}
var staticRenderFns = []

export { render, staticRenderFns }